<template lang='pug' src='./welchorthodontics.pug'></template>

<script>
import Loader from 'components/loader/loader'
import CustomWelchConsultation from 'components/custom/custom-welch-consultation/custom-welch-consultation'
import CustomWelchSections from 'components/custom/custom-welch-sections/custom-welch-sections'

export default {
  name: 'Welch Orthodontics',
  computed: {
    props () {
      return this.$store.state.pages['welchorthodontics']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    this.$store.dispatch('VIEW_NAV', true)
  },
  components: {
    Loader,
    CustomWelchConsultation,
    CustomWelchSections
  }
}
</script>



// WEBPACK FOOTER //
// welchorthodontics.vue?f8ea9a52